import React from "react";
import { Route } from "react-router-dom";

/**
 * RootBrandRoute Component
 * Renders a route at root level when single brand exists for domain
 * Otherwise, returns null so it doesn't match (falls through to brand-scoped routes)
 */
const RootBrandRoute = ({ component: Component, render, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) => {
                const singleBrand = localStorage.getItem('singleBrandForDomain');
                
                // Only render if single brand exists for domain
                if (!singleBrand) {
                    return null;
                }
                
                // Create modified props with brandSlug in match.params
                const modifiedProps = {
                    ...props,
                    match: {
                        ...props.match,
                        params: {
                            ...props.match.params,
                            brandSlug: singleBrand
                        }
                    }
                };
                
                // Use render prop if provided, otherwise use component
                if (render) {
                    return render(modifiedProps);
                }
                
                return <Component {...modifiedProps} />;
            }}
        />
    );
};

export default RootBrandRoute;

